// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-7d0fdaad]{height:10px}.cta[data-v-7d0fdaad]{z-index:10;padding-top:260px;margin-top:-250px}@media(min-width:768px){.cta[data-v-7d0fdaad]{padding-top:220px}}.under[data-v-7d0fdaad]{padding-top:140px;margin-top:-80px}@media(min-width:768px){.under[data-v-7d0fdaad]{margin-top:-300px;padding-top:310px}}p[data-v-7d0fdaad]{color:#a4a4bf!important}", ""]);
// Exports
module.exports = exports;
